import { Component, OnInit, ViewChild } from '@angular/core';
import * as _ from 'lodash';

import { EmailDetailService } from '../services/email-detail.service';
import { SourceService } from '../services/source.service';
import { SessionService } from '../services/session2.service';
import { CacheService } from '../global/ng2-cache/services/cache.service';
import { ErrorService } from '../services/error.service';
import { GlobalMessageService } from '../services/global-message.service';
import { DriftService } from '../services/drift.service';

import { DateRangePickerComponent } from '../global/date-range/date-range-picker.component';
import { Constants, EmailType } from '../global/constants';
//import { Animations } from '../global/animations';

@Component({
  selector: 'app-inbox',
  templateUrl: './inbox.component.html'
  // host: { '[@routerTransition]': 'true' },
  // animations: Animations.page
})
export class InboxComponentOld implements OnInit {

  loadingPage: boolean = true;
  loadingCount: boolean = true;
  session: any;
  currentType: EmailType;
  emails: Array<any> = [];
  totalEmails: number = 0;
  perPage: number = 15;
  numPages: number = 0;
  exportData: string;

  //source dropdown settings
  sources: any[] = [];
  selectedSources: any[] = [];
  sourceDDSettings: any = {
    text: 'Select source(s)',
    unSelectAllText: 'Remove all',
    enableSearchFilter: true,
    badgeShowLimit: 0
  };

  sourceAdd(item) {
    this.filterSource();
  }

  sourceRemove(item) {
    this.filterSource();
  }

  sourceAddAll(items) {
    this.filterSource();
  }

  sourceRemoveAll(items) {
    this.filterSource();
  }


  @ViewChild(DateRangePickerComponent) datePicker: DateRangePickerComponent;

  dateRangeOptions: any = {
    minDate: '01/01/2015',
    format: 'MM/DD/YYYY',
    autoApply: true
  };

  constructor(private sessionService: SessionService,
    private cacheService: CacheService,
    private errorService: ErrorService,
    private emailDetailService: EmailDetailService,
    private sourceService: SourceService,
    private globalMessageService: GlobalMessageService,
    private driftService: DriftService,
    private constants: Constants) { }

  ngOnInit() {
    this.session = this.cacheService.get('session');
    if (!this.session) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.session = session;
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  filterDate(range: any) {
    this.dateRangeOptions.startDate = range.start;
    this.dateRangeOptions.endDate = range.end;

    if (range.numDays) {
      this.session.inbox_filters.days = range.numDays;
      this.session.inbox_filters.range = null;
    }
    else {
      this.session.inbox_filters.days = 0;
      this.session.inbox_filters.range = {
        start: range.start,
        end: range.end
      }
    }

    this.session.inbox_filters.current_page = 0;
    this.session.inbox_filters.new_page = 1;
    this.session.inbox_filters.firstId = null;
    this.session.inbox_filters.lastId = null;
    this.resetData(false);
    this.saveSession();
  }

  filterType(type: EmailType) {
    this.currentType = type;
    this.session.inbox_filters.type = type.typeName;
    this.session.inbox_filters.current_page = 0;
    this.session.inbox_filters.new_page = 1;
    this.session.inbox_filters.firstId = null;
    this.session.inbox_filters.lastId = null;
    this.resetData(false);
    this.saveSession();
  }

  filterSource() {
    //12-31-17 changing how selected sources are stored in session
    // the next line can be deleted after 3 months or so..say March of 2018?
    delete this.session.inbox_filters.source;

    this.session.inbox_filters.sources = _.map(this.selectedSources, (s: any) => { return s.id });
    this.session.inbox_filters.current_page = 0;
    this.session.inbox_filters.new_page = 1;
    this.session.inbox_filters.firstId = null;
    this.session.inbox_filters.lastId = null;
    this.resetData(false);
    this.saveSession();
  }

  filterSearch() {
    this.session.inbox_filters.current_page = 0;
    this.session.inbox_filters.new_page = 1;
    this.session.inbox_filters.firstId = null;
    this.session.inbox_filters.lastId = null;
    this.resetData(false);
    this.saveSession();
  }

  changePage(page) {
    this.changePageInternal(this.session.inbox_filters.new_page, page);
  }

  getTypeClass(type: string) {
    let cssClass: string = 'category-3';
    let et: EmailType =
      this.constants.emailTypes.find((et) => {
        return et.display == type;
      });
    if (et) {
      cssClass = et.cssClass;
    }
    return cssClass;
  }

  export() {

    this.globalMessageService.message('Your export should download in the next few seconds');
    var payload = {
      startDate: this.dateRangeOptions.startDate,
      endDate: this.dateRangeOptions.endDate,
      type: this.session.inbox_filters.type,
      recipient: this.session.inbox_filters.recipient,

    };

    if (this.session.inbox_filters.sources.length > 0 && this.session.inbox_filters.sources.length != this.sources.length) {
      payload['source'] = this.session.inbox_filters.sources;
    }

    this.emailDetailService.getExport(payload).subscribe(
      (result: any) => {
        this.exportData = result._body;
        this.driftService.track('generated-export', { type: 'inbox' });
        this.driftService.track('generated-export', { type: 'inbox' });
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'inbox.component', 'export');
      }
    );
  }

  reset() {
    this.resetFilters();
    this.initView();
    this.datePicker.refresh();
    this.globalMessageService.message('Inbox filters reset');
  }

  private initView() {
    // make sure inbox filters exist for this user
    if (!this.session.inbox_filters || !this.session.inbox_filters.last_changed) {
      this.resetFilters();
    }

    var now = new Date();
    var lastUpdate = new Date(this.session.inbox_filters.last_changed);
    if (now.getTime() - lastUpdate.getTime() > 900000) {
      // 900000ms = 15 minutes. Let's reset filters if it's been more than 15 minutes since they were last last changed
      this.resetFilters();
    }

    this.currentType = this.constants.emailTypes.find((i) => {
      return i.typeName == this.session.inbox_filters.type;
    });

    if (this.session.inbox_filters.range) {
      // custom range is currently selected
      this.dateRangeOptions.startDate = new Date(this.session.inbox_filters.range.start);
      this.dateRangeOptions.endDate = new Date(this.session.inbox_filters.range.end);
    }
    else {
      // standard "time ago" is currently selected
      this.dateRangeOptions.endDate = new Date();
      this.dateRangeOptions.startDate = new Date();
      if (this.session.inbox_filters.days > 0) {
        this.dateRangeOptions.startDate.setDate(this.dateRangeOptions.endDate.getDate() - this.session.inbox_filters.days + 1);
      }
      else {
        // special case for "yesterday"
        this.dateRangeOptions.startDate.setDate(this.dateRangeOptions.endDate.getDate() - 1);
        this.dateRangeOptions.endDate.setDate(this.dateRangeOptions.endDate.getDate() - 1);
      }
    }

    //make sure inbox_filters.sources exist
    if (!this.session.inbox_filters.sources) {
      this.session.inbox_filters.sources = [];
    }

    // pre-load sources in case they are needed
    this.sourceService.getSources().subscribe(
      (result: any) => {
        this.sources = _.map(result, (s: any) => {
          return { id: s._id, itemName: (s.email_address.length > 26 ? (s.email_address.substring(0, 23) + '...') : s.email_address) };
        });

        //mark any sources selected that are in the session
        this.session.inbox_filters.sources.forEach(s => {
          var found_source = _.find(this.sources, (source: any) => {
            return source.id == s;
          })
          if (found_source) {
            this.selectedSources.push(found_source);
          }
        });


        this.resetData(true);
      },
      error => {

      }
    )
  }

  private resetData(fresh: boolean) {
    if (fresh) {
      this.changePageInternal(0, this.session.inbox_filters.new_page);
    }
    else {
      this.changePageInternal(this.session.inbox_filters.current_page, this.session.inbox_filters.new_page);
    }

    this.loadingCount = true;

    var countPayload: any = {
      startDate: this.dateRangeOptions.startDate,
      endDate: this.dateRangeOptions.endDate,
      type: this.session.inbox_filters.type,
      recipient: this.session.inbox_filters.recipient,
    };
    if (this.session.inbox_filters.sources.length > 0 && this.session.inbox_filters.sources.length != this.sources.length) {
      countPayload['source'] = this.session.inbox_filters.sources;
    }

    this.emailDetailService.getCount(countPayload).subscribe(
      (result: any) => {
        this.totalEmails = result.count
        if (this.totalEmails == 0) {
          this.emails = [];
          this.loadingPage = false;
        }
        else {
          this.numPages = Math.floor(this.totalEmails / this.perPage);
          if (this.totalEmails % this.perPage > 0) {
            this.numPages++;
          }
        }
        this.loadingCount = false;
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'inbox.component', 'resetData');
      }
    );
  }

  private changePageInternal(currentPage, newPage) {
    this.loadingPage = true;
    var startDT = new Date();
    startDT.setTime(startDT.getTime() - (this.session.inbox_filters.days * 24 * 60 * 60 * 1000));
    var query = {
      startDate: this.dateRangeOptions.startDate,
      endDate: this.dateRangeOptions.endDate,
    };

    if (this.session.inbox_filters.type != 'all') {
      query['type'] = this.session.inbox_filters.type;
    }

    if (this.session.inbox_filters.recipient.length > 0) {
      query['recipient'] = this.session.inbox_filters.recipient;
    };

    if (this.session.inbox_filters.sources.length > 0 && this.session.inbox_filters.sources.length != this.sources.length) {
      query['source'] = this.session.inbox_filters.sources;
    }

    var options = {
      current_page: currentPage,
      new_page: newPage,
      firstId: this.session.inbox_filters.firstId,
      lastId: this.session.inbox_filters.lastId,
      query: query,
      count: this.perPage
    }
    this.emailDetailService.getPaginated(options).subscribe(
      (result: any) => {
        this.emails = result;
        if (this.emails.length > 0) {
          this.emails.forEach((e) => {
            e.domain = e.from_address.split('@')[1];
            e.type = this.constants.emailTypes.find((ct) => {
              return ct.typeName == e.type;
            }).display;

            if (e.typeData.origin_type == 101) {
              e.origin = "Reply";
            }
            else {
              e.origin = "Direct";
            }
          });
          this.session.inbox_filters.current_page = currentPage;//$scope.userSession.inbox_filters.new_page;
          this.session.inbox_filters.new_page = newPage;//page;
          this.session.inbox_filters.firstId = this.emails[0].date;
          this.session.inbox_filters.lastId = this.emails[this.emails.length - 1].date;
          this.saveSession();
        }
        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'inbox.component', 'changePageInternal');
      }
    );
  }

  private saveSession() {
    this.session.inbox_filters.last_changed = new Date();
    this.sessionService.saveSession(this.session).subscribe(
      (result: any) => {
        // Nothing
      },
      err => {
        this.errorService.log(err, 'inbox.component', 'saveSession');
      }
    )
  }

  private resetFilters() {
    this.session.inbox_filters = {
      range: null,
      days: 30,
      type: 'all',
      sources: [],
      recipient: '',
      current_page: 0,
      new_page: 1,
      firstId: null,
      lastId: null
    };
    this.selectedSources = [];
    this.saveSession();
  }

}



// WEBPACK FOOTER //
// ./client/app/inbox-old/inbox.component.ts